$(function () {
  let slicktype = "";
  const breakPoint = 768;
  $('.slider').slick({
    variableWidth: true, // スライド幅の自動計算を無効化
    arrows: true,
    autoplay: true,
    swipeToSlide: true,
    touchThreshold: 10,
    speed: 500,
    autoplaySpeed: 4e3,
    adaptiveHeight: false,
    dots: true,
    slidesToShow: 1,
    pauseOnHover: !1,
    pauseOnFocus: !1
  });

  function slideAuto() {
    for (var i = 0; i < $('.mv_anime li').length; i++) {
      if (i == 0) {
        $('.mv_anime').find('.no' + (i + 1)).addClass('last');
      }
      $('.mv_anime').find('.no' + (i + 1)).removeClass('no' + (i + 1));

      if (i != 0 || i != $('.mv_anime li').length - 1) {
        $('.mv_anime').find('.no' + (i + 2)).addClass('no' + (i + 1));
      }

      if (i == $('.mv_anime li').length - 1) {
        $('.mv_anime').find('.last').addClass('no' + $('.mv_anime li').length);
        $('.mv_anime').find('.last').removeClass('last');
      } else {
      }
    }
    $('.mv_anime li img').addClass('anime');
    setTimeout(function () {
      $('.mv_anime li img').removeClass('anime');
    }, 3e3);
  }

  slideTimer = setInterval(slideAuto, 4e3);

  // スクロールのオフセット値
  var offsetY = -10;
  // スクロールにかかる時間
  var time = 500;

  // ページ内リンクのみを取得
  $('a[href^="#"]').click(function () {
    // スクロールの速度
    var speed = 400; // ミリ秒
    // アンカーの値取得
    var href = $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を数値で取得
    var position = target.offset().top;
    // スムーススクロール
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });
});